import clsx from 'clsx';
import React from 'react';

import styles from './InfoItem.module.scss';

interface InfoItemProps {
  label: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const InfoItem: React.FC<InfoItemProps> = ({ label, children, className }) => (
  <div className={clsx(styles.infoItem, className)}>
    <div className={styles.label}>{label}</div>
    <div className={styles.value}>{children}</div>
  </div>
);
